import * as React from 'react';
import Box from '@mui/material/Box';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import Newdocuments from './component/newDocument/Newdocuments';

import { Route, Link, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import { AddHeader, AddDetail, AddImages } from '../redux/features/document/documentHeaderSlice';
import FetchApi from '../customhooks/Functionapi';
import { Button } from '@mui/material';
import { UpdateDetailList } from '../customhooks/Functiondocument';
import Swal from 'sweetalert2';


export default function NewDocument(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { id } = useParams();
  const documentHeader = useSelector((state) => state.documentHeader.valueHeader);
  const documentDetial = useSelector((state) => state.documentHeader.valueDetail);


  const d = new Date();
  let convertdate = ""
  let convertmonth = d.getMonth() + 1;

  if (d.getDate() < 10) {
    convertdate = "0" + d.getDate();
  }
  else {
    convertdate = d.getDate();
  }
  if (d.getMonth() + 1 < 10) {
    convertmonth = "0" + convertmonth
  }
  else {
    convertmonth = convertmonth
  }

  var datenow = d.getFullYear() + "-" + convertmonth + "-" + convertdate
  var datenowtime = d.getFullYear() + "-" + convertmonth + "-" + convertdate + " " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds()

  const FetchApis = new FetchApi();

  function getdataheader(data) {
    dispatch(AddHeader(data))
  }

  function getdatadetail(data) {
    dispatch(AddDetail(data))
  }

  function getdataImages(data) {
    dispatch(AddImages(data))
  }


  // ข้อมูลก่อน save
  const isSaveClose = () => {

    const newObj = {
      ...documentHeader,
      stamptimeUpdate: datenowtime
    };


    if (documentHeader.FlowrunId != "") {
      isInsertData(newObj)
      UpdateDetailList(documentDetial)

      Swal.fire({
        title: "แจ้งเตือน!",
        text: "คุณได้ทำการสร้างเอกสารเรียบร้อยแล้ว!",
        icon: "success"
      });

      setTimeout(() => {
        window.location.href = '/documents'

      }, 700);

    } else {
      Swal.fire({
        title: "แจ้งเตือน",
        text: "คุณยังไม่ได้เลือกเป็น flow อนุมัติ",
        icon: "warning"
      });

    }

  };

  // insert header
  const isInsertData = (datainsert) => {
    FetchApis.FethcPost(`/document/createdocument`, datainsert).then(res => {
      if (res.status == 200) {
        // window.location.href=`/newducument/${res.insertId}`
      } else {
        console.log(res)
      }
    })

  }

  function refresh() {
    window.location.reload();
  }

  return (
    <Box sx={{ width: '100%', typography: 'body1', backgroundColor: '#f5f7fa', minHeight: '100vh' }}>
      <div className='nd-toolbar'>
        <div>
          <div className='nd-toolbar-title'>สร้างเอกสารใหม่</div>
          <div className='nd-toolbar-sub'>
            {documentHeader.JournalCode ? `เลขที่เอกสาร ${documentHeader.JournalCode}` : 'กรอกข้อมูลคำร้องขอ แล้วกดบันทึก'}
          </div>
        </div>
        <div className='nd-toolbar-actions'>
          <Button variant="outlined" color='inherit' startIcon={<CloseIcon />} onClick={() => refresh()}>ยกเลิก</Button>
          <Button variant="contained" color="success" startIcon={<SaveIcon />} onClick={() => isSaveClose()}>บันทึก</Button>
        </div>
      </div>
      <Newdocuments getdataheader={getdataheader}
        getdatadetail={getdatadetail}
        getdataImages={getdataImages}
        insertId={id}
      />
    </Box>
  );
}
